<div class="login-shell">
  <div class="google-entry">
    <img class="brand-mark" src="assets/images/logo/logo-icon.png" alt="Logo" />
    <div #googleButton id="googleButton"></div>
  </div>
</div>
